module.exports = __webpack_public_path__ + "img/3.7febdfd6.jpg";